<div class="single-center-pane">
  <div
    *ngIf="fromIpdb == '1'"
    class="d-flex align-items-center go-back-btn"
    matTooltip="Go back"
    matTooltipPosition="above"
    role="button"
    (click)="navigateToIpdb()"
  >
    <mat-icon>keyboard_backspace</mat-icon>
  </div>
  <div
    *ngIf="!fromIpdb"
    class="d-flex align-items-center go-back-btn"
    matTooltip="Go back"
    matTooltipPosition="above"
    role="button"
    (click)="navigateToAssessmentCentral()"
  >
    <mat-icon>keyboard_backspace</mat-icon>
  </div>
  <div class="d-flex">
    <h5 class="m-0">Assessment Catalog Library</h5>
    <div class="ml-auto">
      <button
        mat-flat-button
        mat-button
        color="primary"
        class="bg-primary text-white mr-2"
        (click)="navigateToAssessmentCentral()"
      >
        Assessments
      </button>
      <button
        mat-flat-button
        mat-button
        color="primary"
        class="bg-primary text-white"
        (click)="navigateToLibrary()"
        *ngIf="readMode"
      >
        <mat-icon>add</mat-icon> Assessment
      </button>
    </div>
  </div>
  <div
    *ngIf="!readMode"
    class="mt-2 d-flex align-items-center justify-content-center mb-2"
  >
    <button
      mat-flat-button
      color="primary"
      class="mr-1"
      style="width: 100%"
      (click)="templateDownload()"
    >
      <mat-icon>cloud_download</mat-icon> &nbsp;
      <span>Download Template</span>
    </button>
    <input
      (change)="this.onFilechange($event)"
      class="form-control"
      type="file"
      #formFile
      hidden
    />
    <button
      mat-flat-button
      color="primary"
      class="mr-1"
      style="width: 100%"
      (click)="formFile.click()"
    >
      <mat-icon>cloud_upload</mat-icon> &nbsp;
      <span>Upload Template</span>
    </button>
  </div>
  <app-loading *ngIf="!templatesLoaded"></app-loading>
  <div *ngIf="templatesLoaded">
    <app-loading *ngIf="!isDataLoaded"></app-loading>
    <app-assessment-library
      [isDataLoaded]="isDataLoaded"
      [filteredTemplate]="filteredTemplate"
      [unCategorizedTemplates]="unCategorizedTemplates"
    ></app-assessment-library>
  </div>
</div>
